(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('escapeHtml', function () {
        return function (str) {
            if (!str || !str.replace) {
                return str;
            }
            return str.replace(/['"><&]/g, function (match) {
                return {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    '\'': '&#039;'
                }[match] || '';
            });
        };
    });
}());